import { styled } from "@phntms/css-components";
import {Section} from "../../components/Section";
import {BigText, Caption} from "../../components/Typography";
import styles from "./styles.module.scss";


export const StyledCarouselSection = styled(Section, {
  css: [ styles.carouselSection ]
})

export const CarouselContainer = styled('div', {
  css: [styles.carouselContainer, ],
  variants: {
    size: {
      '4/3': styles.size_4_3,
      '16/9': styles.size_16_9,
      'square': styles.size_square,
    }
  }
})

export const CarouselFigure = styled('figure', {
  css: [styles.carouselFigure, ],
  variants: {
    fullscreenToggle: {
      true: ["fullscreen-toggle"]
    }
  }
})





export const Overlay = styled('figcaption', {
  css: styles.overlay
})

export const ImageCaption = styled(Caption, {
  css: styles.imageCaption
})

export const ImageTitle = styled(BigText, {
  css: styles.imageTitle
})

